
import { supabase } from '@/integrations/supabase/client';
import { WizardFormData } from '../types';

export const useUserSubmit = () => {
  const handleUserAssignment = async (formData: WizardFormData, providerId: string) => {
    if (!formData.user) {
      return null;
    }
    
    let userId = null;
    
    if (formData.user.assignmentType === 'existing') {
      // Assign existing user to the provider
      userId = formData.user.id;
      
      // Update user role in the database
      if (userId && providerId) {
        // First, check if the user already has a role
        const { data: roleData, error: roleError } = await supabase
          .from('user_roles')
          .select('id, role')
          .eq('user_id', userId)
          .single();
          
        if (!roleError && roleData) {
          // Update the existing role to include provider_id
          await supabase
            .from('user_roles')
            .update({ provider_id: providerId })
            .eq('id', roleData.id);
        }
      }
    } else {
      // Create new user with strategy_provider role
      const { data: userData, error: userError } = await supabase.auth.admin.createUser({
        email: formData.user.email || '',
        password: formData.user.password || '',
        email_confirm: true // Auto-confirm email
      });
      
      if (userError) {
        throw new Error(`Error creating user: ${userError.message}`);
      }
      
      userId = userData.user.id;
      
      // Assign the strategy_provider role, first/last name, and link to the provider
      const { error: roleError } = await supabase
        .from('user_roles')
        .insert({
          user_id: userId,
          role: 'strategy_provider',
          provider_id: providerId,
          first_name: formData.user.firstName,
          last_name: formData.user.lastName
        });
        
      if (roleError) {
        throw new Error(`Error assigning user role: ${roleError.message}`);
      }
    }
    
    return userId;
  };

  return { handleUserAssignment };
};
